// +----------------------------------------------------------------------
// | Desc:路由配置
// +----------------------------------------------------------------------
import Vue from "vue";
import VueRouter from "vue-router";
import {
    routers
} from "@/config/url";
Vue.use(VueRouter);
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routers
});

// +----------------------------------------------------------------------
// | Desc:为空验证
// +----------------------------------------------------------------------
function $isblank(value) {
    const emptyValues = [null, "null", "NULL", "undefined", undefined, 'UNDEFINED', ''];
    if (emptyValues.includes(value)) {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (typeof value === 'object' && value !== null && Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
    }
    return false;
}

function $jsonParse(jsonString) {
    if ($isblank(jsonString)) {
        return "";
    };
    return JSON.parse(jsonString);
}


// +----------------------------------------------------------------------
// | Desc:路由判断登录根据路由配置文件的参数
// +----------------------------------------------------------------------
router.beforeEach((to, from, next) => {

    //404拦截@@@@@@@@@@@@@@@@@@@@@@@@@@
    const matched = router.match(to)
    if (matched.name == '404') {
        next();
        return;
    };


    //无需拦截的路由@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (!to.meta.requireAuth) {
        next();
        return;
    }

    //登录状态@@@@@@@@@@@@@@@@@@@@@@@@@@
    var token = localStorage.getItem('token');
    if ($isblank(token)) {
        var token = sessionStorage.getItem('token')
    };
    var isLogin = !$isblank(token);
    var user = localStorage.getItem("user");
    var user = $jsonParse(localStorage.getItem("user"));
    var isUser = !$isblank(user);
    if (!isUser) {
        isLogin = false;
    };

    //未登录-访问权限页@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (!isLogin && to.name != 'login') {
        router.push({
            name: 'login'
        });
        return;
    };
    //未登录-访问登录页@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (!isLogin && to.name == 'login') {
        next();
        return;
    };
    //已登录-访问权限页@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (isLogin && to.name != 'login') {
        //下方验证权限
    };

    //已登录-访问登录页@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (isLogin && to.name == 'login') {
        router.push({
            name: 'index'
        });
        return;
    };

    //user权限拦截@@@@@@@@@@@@@@@@@@@@@@@@@@
    var path = to.path;
    var authPageUrl = user.authPageUrl;
    var authPageAllUrl = user.authPageAllUrl;
    if ($isblank(authPageUrl)) {
        var isAuth = false;
    } else {
        var isAuth = authPageUrl.includes(path);
    }

    //判断是否需要鉴权访问@@@@@@@@@@@@@@@@@@@@@@@@@@
    if ($isblank(authPageAllUrl)) {
        isAuth = true;
    } else {
        if (!authPageAllUrl.includes(path)) {
            isAuth = true;
        };
    };


    if (!isAuth) {
        router.push({
            name: 'error'
        });
        return;
    };

    //放行路由@@@@@@@@@@@@@@@@@@@@@@@@@@
    next();
});
export default router;